export default "__VITE_ASSET__Cg$BHmzc__"